<div class="upload-container">
  <input
    #fileInput
    type="file"
    id="file-upload"
    multiple
    class="file-input"
    [accept]="getAcceptAttribute()"
    [disabled]="isUploadDisabled()"
    (change)="onFileSelected($event)"
  />

  <!-- Preview Section (shows when only preview files exist) -->
  @if (previewFiles.length > 0 && !hasActualUploadedFiles) {
    <div class="preview-section">
      <div class="preview-header">
        <label class="preview-label" [htmlFor]="'preview'">Preview</label>
      </div>
      <div class="file-preview">
        <lib-uploaded-file-preview
          [files]="previewFiles"
          [highlightRemovableFiles]="false"
          [readOnly]="readOnly"
          [showLargePreview]="showLargePreview"
          (handleDeleteFileEvent)="removeFile($event)"
        />
      </div>
    </div>
  }

  <!-- Upload Box (shows when no actual uploaded files) -->
  @if (!readOnly && !hasActualUploadedFiles) {
    <div
      class="upload-box"
      [ngClass]="{
        disabled: disableFileDrop || isUploadDisabled(),
        dragging: isDragging,
      }"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
    >
      <label for="file-upload">
        <div class="upload-icon">
          <g99-icon-btn
            [icon]="uploadLogo"
            [height]="26"
            [width]="26"
            [strokeColor]="'#fff'"
          />
        </div>
        <p class="upload-text">Drag files or click to upload</p>
        <p class="upload-subtext"
          >Share your files easily. Up to
          {{ maxFiles === 1 ? '1 file' : (maxFiles || 5) + ' files' }} can be
          uploaded
        </p>

        <div class="supported-formats">
          @if (allowedFileTypes && allowedFileTypes.length > 0) {
            @for (format of allowedFileTypes; track $index) {
              <span class="format-tag">{{ format }}</span>
            }
          } @else {
            <span class="format-tag">All file types</span>
          }
          <a
            target="_blank"
            class="info-icon"
            aria-label="View full list of supported file types"
            [href]="supportedFileTypesUrl"
          >
            <i class="pi pi-info-circle"></i>
          </a>
        </div>
      </label>
    </div>

    <!-- Warning Message -->
    @if (totalSize && maxTotalSizeMB) {
      <lib-file-upload-size-warning
        [maxTotalSizeMB]="maxTotalSizeMB"
        [totalSize]="totalSize"
        [fileCount]="actualUploadedFiles.length"
      />
    }
  }

  <!-- File Upload List (shows when actual files are uploaded) -->
  @if (hasActualUploadedFiles) {
    <div class="file-preview-header">
      <div class="file-count">
        {{
          actualUploadedFiles.length === 1 ? 'Uploaded File' : 'Uploaded Files'
        }}
        <span class="file-count-text"
          >({{ actualUploadedFiles.length }}/{{ maxFiles }} files)
        </span>
      </div>

      @if (!readOnly && totalFilesCount < maxFiles) {
        <g99-button
          variant="small"
          color="secondary"
          [svgIcon]="addIcon"
          [iconHeight]="10"
          [iconWidth]="10"
          [fontSize]="'14px'"
          [showIconOnMobile]="true"
          (buttonClick)="triggerAddMoreFiles()"
        >
          Add more
        </g99-button>
      }
    </div>

    <div class="file-preview">
      <lib-uploaded-file-preview
        [files]="actualUploadedFiles"
        [highlightRemovableFiles]="isOverSizeLimit()"
        [readOnly]="readOnly"
        (handleDeleteFileEvent)="removeFile($event)"
      />
    </div>
  }
</div>
